// components/pricing/PricingCard/index.jsx
import React from "react";
import { Check } from "lucide-react";
import {
	Card,
	PopularBadge,
	PlanName,
	PriceContainer,
	Description,
	FeatureList,
	FeatureSection,
	StyledButton,
	CreditHighlight,
	PeriodBadge,
} from "./styles";
import { getPlanInterval } from "../../../config/subscriptionPlans";
import { formatCurrency } from "../../../utils/format";

const PricingCard = ({ plan, onSelect, isPopular }) => {
	const interval = getPlanInterval(plan.id);

	const getCreditsPerPeriod = () => {
		switch (plan.interval) {
			case "quarterly":
				return "per quarter";
			case "bimonthly":
				return "per 2 months";
			default:
				return "per month";
		}
	};

    console.log(plan)

	return (
		<Card
			initial={{ opacity: 0, y: 20 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.3 }}
			isPopular={isPopular}
		>
			{isPopular && <PopularBadge>Most Popular</PopularBadge>}

			<PlanName>{plan.name}</PlanName>

			<PriceContainer>
				<div className="price">
					<span className="currency">Rs</span>
					<span className="amount">{formatCurrency(plan.price).replace("Rs", "")}</span>
					<span className="interval">{interval}</span>
				</div>
			</PriceContainer>

			<PeriodBadge interval={plan.interval}>
				{plan.interval === "quarterly"
					? "Quarterly Payment"
					: plan.interval === "bimonthly"
					? "Bi-monthly Payment"
					: "Monthly Payment"}
			</PeriodBadge>

			<CreditHighlight>
				<h4>{plan.periodCredits} Hours</h4>
				<p>Session Credits {getCreditsPerPeriod()}</p>
				<span>
					Additional credits: Rs{plan.features.addOnCredits.price}/hour
				</span>
			</CreditHighlight>

			<Description>
				Perfect for{" "}
				{plan.interval === "quarterly"
					? "quarterly"
					: plan.interval === "bimonthly"
					? "bi-monthly"
					: "monthly"}{" "}
				baby photoshoots
			</Description>

			<FeatureSection>
				<h4>Session Details</h4>
				<FeatureList>
					{plan.features.extras.map((feature, index) => (
						<li key={index}>
							<Check size={20} />
							{feature}
						</li>
					))}
				</FeatureList>
			</FeatureSection>

			<StyledButton
				variant={isPopular ? "primary" : "outlined"}
				onClick={() => onSelect(plan)}
			>
				Choose Plan
			</StyledButton>
		</Card>
	);
};

export default PricingCard;
